import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "./api";
import { showError } from "./utils/alert";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const login = async (e) => {
    e.preventDefault();
    if (!email || !password) return;

    setLoading(true);
    try {
      const res = await api.post("/auth/login", {
        email,
        password,
      });

      localStorage.setItem("token", res.data.access_token);
      if (res.data.refresh_token) {
        localStorage.setItem("refresh_token", res.data.refresh_token);
      }
      if (res.data.is_admin != null) {
        localStorage.setItem("is_admin", String(res.data.is_admin));
      } else {
        localStorage.removeItem("is_admin");
      }
      navigate("/dashboard");
    } catch (err) {
      const apiMessage = err?.response?.data?.msg || err?.response?.data?.message;
      showError(apiMessage || "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="d-flex align-items-center justify-content-center min-vh-100 skedq-login-bg">
      <div className="card shadow-sm" style={{ minWidth: 360 }}>
        <div className="card-body">
          <h4 className="card-title mb-4 text-center">Admin Login</h4>
          <form onSubmit={login}>
            <div className="mb-3">
              <label className="form-label">Email</label>
              <input
                className="form-control"
                placeholder="admin@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Password</label>
              <input
                type="password"
                className="form-control"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            <button
              type="submit"
              className="btn skedq-accent-btn w-100"
              disabled={loading}
            >
              {loading ? "Signing in..." : "Login"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
